import { useEffect } from 'react'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { appConfigStateSelectors } from '@tabeeb/modules/appConfigState'
import { useUnreadChatsCount } from '@tabeeb/modules/chat/hooks'

import { ConnectedTvOutlined, MarkEmailUnreadOutlined } from '@mui/icons-material'

import { NavbarItem } from '@collaborate-health/uikit'
import { useSessionTitleFormatter } from '@tabeeb/modules/shared/utils/text'

const SessionsTab = () => {
  const { f } = useSessionTitleFormatter()

  const enabled = useSelector(
    (state) =>
      appConfigStateSelectors.getIsChatEnabled(state) &&
      appConfigStateSelectors.getIsUnreadSessionChatsIndicatorEnabled(state)
  )

  const { count: unreadChatsCount, invalidate: onRefresh } = useUnreadChatsCount(enabled)
  const display = useSelector(appConfigStateSelectors.getIsContentsFeatureEnabled)

  useEffect(() => {
    if (enabled) {
      onRefresh()
    }
  }, [enabled, onRefresh])

  if (!display) {
    return null
  }

  return (
    <NavbarItem
      name={f('Sessions')}
      badgeVariant='dot'
      badge={unreadChatsCount ? <span /> : null}
      href={Routes.mySessions}
      icon={<ConnectedTvOutlined />}
      adornment={unreadChatsCount ? <MarkEmailUnreadOutlined color='primary' /> : null}
      onClick={() => onRefresh()}
    />
  )
}

export default SessionsTab

